import axios from 'axios';

import { REST_API_BASE_URL } from '../../config';
const AUTH_REST_API_BASE_URL = REST_API_BASE_URL;

// Function to register a user
export const registerAPICall = (registerObj) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/register`, registerObj);

// Function to log in a user
export const loginAPICall = (loginObj) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/login`, loginObj);

// Function to store the token in local storage
export const storeToken = (token) => localStorage.setItem('token', token || '');

// Function to retrieve the token from local storage
export const getToken = () => localStorage.getItem('token');

// Function to store the role in local storage
export const storeRole = (role) => localStorage.setItem('role', role || '');

// Function to retrieve the role from local storage
export const getRole = () => localStorage.getItem('role');

// Function to store groups in local storage
export const storeGroups = (groups) =>
  localStorage.setItem('groups', groups || '');

// Function to retrieve groups from local storage
export const getGroups = () => localStorage.getItem('groups');

// Function to save the logged in user's username in session storage
export const saveLoggedInUser = (username) =>
  sessionStorage.setItem('authenticatedUser', username || '');

// Function to reset the password for a user
export const resetPassword = (email) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/resetPassword?email=${email}`);

// Function to save the new password for a user
export const savePassword = (saveObj) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/savePassword`, saveObj);

// Function to confirm user registration
export const registrationConfirm = (token) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/registrationConfirm/${token}`);

export const invitationConfirm = (token) =>
  axios.post(`${AUTH_REST_API_BASE_URL}/invitationConfirm/${token}`);

// Function to check if a user is logged in
export const isUserLoggedIn = () => {
  const username = sessionStorage.getItem('authenticatedUser');
  return !!username;
};

// Function to get the logged in user's username from session storage
export const getLoggedInUser = () =>
  sessionStorage.getItem('authenticatedUser');

// Function to log out the user — invalidates the token server-side then clears local storage
export const logout = async (): Promise<void> => {
  const token = getToken();
  try {
    await axios.post(
      `${AUTH_REST_API_BASE_URL}/logout`,
      {},
      {
        withCredentials: true,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      },
    );
  } catch {
    // Proceed with local cleanup even if the server call fails
  }
  localStorage.clear();
  sessionStorage.clear();
};
